export const EVENT_MOUNT                 = 'mount';
export const EVENT_MOUNTED               = 'mounted';
export const EVENT_FOCUS                 = 'focus';
export const EVENT_BLUR                  = 'blur';
export const EVENT_READONLY              = 'readOnly';
export const EVENT_KEYDOWN               = 'keydown';
export const EVENT_INPUT                 = 'input';
export const EVENT_NEWLINE               = 'newline';
export const EVENT_CHANGE                = 'change';
export const EVENT_CHANGED               = 'changed';
export const EVENT_COMPOSITION_START     = 'compositionStart';
export const EVENT_COMPOSITION_UPDATE    = 'compositionUpdate';
export const EVENT_COMPOSITION_END       = 'compositionEnd';
export const EVENT_ANCHOR_LINE_CHANGED   = 'anchorLineChanged';
export const EVENT_FOCUS_LINE_CHANGED    = 'focusLineChanged';
export const EVENT_COPY                  = 'copy';
export const EVENT_CUT                   = 'cut';
export const EVENT_PASTE                 = 'paste';
export const EVENT_KEYMAP                = 'keymap';
export const EVENT_CHUNK_MOVED           = 'chunkMoved';
export const EVENT_CHUNK_SUPPLIED        = 'chunkSupplied';
export const EVENT_SELECTING             = 'selecting';
export const EVENT_SELECTED              = 'selected';
export const EVENT_SELECTION_CHANGE      = 'selectionChanged';
export const EVENT_SCROLL                = 'scroll';
export const EVENT_SCROLLED              = 'scrolled';
export const EVENT_SCROLLER_SCROLL       = 'scrollerScroll';
export const EVENT_WINDOW_SCROLL         = 'windowScroll';
export const EVENT_RESIZE                = 'resize';
export const EVENT_SCROLL_WIDTH_CHANGED  = 'scrollWidthChanged';
export const EVENT_SCROLL_HEIGHT_CHANGED = 'scrollHeightChanged';
export const EVENT_SYNCED                = 'synced';
export const EVENT_CONTEXT_MENU_OPENED   = 'contextMenuOpened';
export const EVENT_CONTEXT_MENU_CLOSED   = 'contextMenuClosed';
export const EVENT_CONTEXT_MENU_CLICKED  = 'contextMenuClicked';
export const EVENT_RESET                 = 'reset';
export const EVENT_INIT_STYLE            = 'initStyle';
export const EVENT_FONT_LOADED           = 'fontLoaded';
export const EVENT_DESTROYED             = 'destroyed';
